/**
 * DialogoDeConfirmacao.js — a pergunta antes do que não se desfaz com um clique
 * CI Sistemas de Informática Ltda. — AcessoiD (Onda 101)
 *
 * Um diálogo de verdade, e não `window.confirm`: a confirmação precisa MOSTRAR o que
 * vai mudar (a lista de alterações do motor, a consequência de trocar a vertical), e
 * o `confirm` do navegador só tem uma frase e dois botões sem nome.
 *
 * O foco nasce em CANCELAR. Quem aperta Enter por reflexo cancela; para confirmar é
 * preciso querer. Esc cancela. Enquanto `ocupado`, nada fecha o diálogo — a gravação
 * está em curso, e fechar faria parecer que foi cancelada.
 */
import React, { useEffect, useRef } from 'react';

export default function DialogoDeConfirmacao({
  titulo, children, rotuloConfirmar = 'Confirmar', rotuloCancelar = 'Cancelar',
  perigo = false, ocupado = false, erro = null, aoConfirmar, aoCancelar,
}) {
  const cancelar = useRef(null);

  useEffect(() => { cancelar.current?.focus(); }, []);
  useEffect(() => {
    const tecla = (e) => { if (e.key === 'Escape' && !ocupado) aoCancelar(); };
    document.addEventListener('keydown', tecla);
    return () => document.removeEventListener('keydown', tecla);
  }, [ocupado, aoCancelar]);

  return (
    <div className="cfg-dialogo-fundo" onMouseDown={(e) => { if (e.target === e.currentTarget && !ocupado) aoCancelar(); }}>
      <div className="cfg-dialogo" role="dialog" aria-modal="true" aria-labelledby="cfg-dialogo-titulo">
        <h2 id="cfg-dialogo-titulo" className="cfg-dialogo-titulo">{titulo}</h2>
        <div className="cfg-dialogo-corpo">{children}</div>
        {erro && <p className="cfg-dialogo-erro" role="alert">{erro}</p>}
        <div className="cfg-dialogo-acoes">
          <button type="button" ref={cancelar} className="cfg-botao" onClick={aoCancelar} disabled={ocupado}>{rotuloCancelar}</button>
          <button type="button" className={`cfg-botao ${perigo ? 'cfg-botao-perigo' : 'cfg-botao-principal'}`} onClick={aoConfirmar} disabled={ocupado}>
            {ocupado ? 'Aplicando…' : rotuloConfirmar}
          </button>
        </div>
      </div>
    </div>
  );
}
